'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./Button.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnchorButton = function AnchorButton(props) {
    return _react2.default.createElement(
        'a',
        { disabled: props.disabled, className: (0, _classnames2.default)('Button', props.className), href: props.href,
            onClick: props.onClickFn, target: props.target },
        props.children
    );
};

AnchorButton.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string]).isRequired,
    onClickFn: _propTypes2.default.func,
    className: _propTypes2.default.string,
    href: _propTypes2.default.string,
    target: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    type: _propTypes2.default.string
};

exports.default = AnchorButton;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/buttons/AnchorButton.js
// module id = 423
// module chunks = 0